module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "upcoming-order-windows"
  }, _vm._l((_vm.listOrderWindowUpcoming), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "upcoming-order-windows-list"
    }, [_c('h4', {
      staticClass: "titleOrderWindow"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'summaryOrderWindow',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v(_vm._s(item.name))])], 1), _vm._v(" "), _c('p', {
      staticClass: "dateOrderWindow"
    }, [_vm._v(_vm._s(_vm.formatDate(item.startDate)) + " >>>> " + _vm._s(_vm.formatDate(item.endDate)))])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56a21f8e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/summary-common/upcomingOrderWindows.vue
// module id = 3195
// module chunks = 0